import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportclasspipe',
})
export class ReportStatusClassPipe implements PipeTransform {
  transform(source:string) {
    if (!source) {
      return undefined;
    }

    let className="";

    if(source.toLocaleLowerCase() == "p"){
      className="status-pending";
    }else if(source.toLocaleLowerCase() == "a"){
      className="status-approved";
    }else if(source.toLocaleLowerCase() =="v"){
      className="status-verified";
    }else if(source.toLocaleLowerCase() =="r"){
      className="status-rejected";
    }else if(source.toLocaleLowerCase() =="s"){
      className="status-submitted";
    }
    return className;

  }
}
// https://stackblitz.com/edit/angular-nevhxm-so?file=src%2Fapp%2Fapp.component.html

// <div *ngFor='let result of results'>
// 	<div [ngClass]='{"myclass": someArray | inArray:result.id }'>
//     {{result.name}}
// 	</div>
// </div>
